const addTrailingSlash = (url) => {
    if (url.endsWith("/")) {
        return url;
    }
    return url + "/";
};

module.exports = { addTrailingSlash };
